import React from 'react'
import StatistikGameComponent from "./StatistikGameComponent";

export default function StatistikGameView({gameId, tournamentId, tournamentGameId}) {

    return <div style={{width: "100%",padding:10}}>
            <StatistikGameComponent gameId={gameId} tournamentId={tournamentId} tournamentGameId={tournamentGameId}/>
        </div>
}
